import { render, staticRenderFns } from "./Tab4.vue?vue&type=template&id=dacfba0e&scoped=true&"
import script from "./Tab4.vue?vue&type=script&lang=ts&"
export * from "./Tab4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacfba0e",
  null
  
)

export default component.exports